'use es6';

import { map, reduce, sortBy, filter, flatten, isEmpty } from 'underscore';
import { propertyLabelTranslator } from 'property-translator/propertyTranslator';
import { getContactPropertiesGroups } from 'FormsUI/api/ContactProperties';
import { getTicketPropertiesGroups } from 'FormsUI/api/TicketProperties';
import { PropertyObjectTypes } from 'FormsUI/constants/PropertyObjectTypes';
import { getPropertyId, getPropertyGroupId } from 'FormsUI/utils/PropertiesUtils';
import { getObjectTypeIdValue } from 'FormsCommonComponents/form-definition/utils/FormFieldUtils';
function parsePropertyGroupsByName(response, parsedProperties) {
  const filteredPropertyGroups = filter(response, propertyGroup => {
    return !isEmpty(propertyGroup.properties);
  });
  return reduce(filteredPropertyGroups, (memo, propertyGroup) => {
    let properties = map(propertyGroup.properties, property => property.property);
    properties = filter(properties, property => Object.prototype.hasOwnProperty.call(parsedProperties, property.id));
    properties = sortBy(properties, property => {
      if (properties.options) {
        // TODO: Should not be modifying the object here.
        property.options = sortBy(property.options, option => option.displayOrder);
      }
      return property.displayOrder;
    });
    properties = map(properties, property => property.id);
    if (!isEmpty(properties)) {
      memo[getPropertyGroupId(propertyGroup)] = Object.assign({}, propertyGroup, {
        displayName: propertyLabelTranslator(propertyGroup.displayName),
        properties
      });
    }
    return memo;
  }, {});
}
function parsePropertyResponse(response) {
  return response.map((propertyTypeGroups, index) => propertyTypeGroups.map(propertyGroup => {
    const groupObjectType = index === 1 ? PropertyObjectTypes.TICKET : PropertyObjectTypes.CONTACT;
    return Object.assign({}, propertyGroup, {
      groupObjectType,
      properties: propertyGroup.properties.filter(({
        property
      }) => property.formField).map(property => {
        property.property.propertyObjectType = groupObjectType;
        property.property.objectTypeId = getObjectTypeIdValue(null, groupObjectType);
        return Object.assign({}, property, {
          property: Object.assign({}, property.property, {
            id: getPropertyId(property.property)
          })
        });
      })
    });
  })).reduce((propertiesArray, propertyArray) => /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
  propertiesArray.concat(...propertyArray), []);
}
function createAction(name) {
  return `@@properties/${name}`;
}
export const REQUEST_PROPERTIES = createAction('REQUEST_PROPERTIES');
export const SUCCEED_FETCHING_PROPERTIES = createAction('SUCCEED_FETCHING_PROPERTIES');
export const RECEIVE_PROPERTIES = createAction('RECEIVE_PROPERTIES');
export const FAIL_FETCHING_PROPERTIES = createAction('FAIL_FETCHING_PROPERTIES');
export const UPDATE_SEARCH_QUERY = createAction('UPDATE_SEARCH_QUERY');
function requestProperties() {
  return {
    type: REQUEST_PROPERTIES
  };
}
function succeedFetchingProperties() {
  return {
    type: SUCCEED_FETCHING_PROPERTIES
  };
}
function failFetchingProperties() {
  return {
    type: FAIL_FETCHING_PROPERTIES
  };
}
export function receiveProperties(propertyGroups, properties) {
  return {
    type: RECEIVE_PROPERTIES,
    propertyGroups,
    properties
  };
}
export function setSearchQuery(searchQuery) {
  return {
    type: UPDATE_SEARCH_QUERY,
    searchQuery
  };
}
export function fetchProperties() {
  return dispatch => {
    dispatch(requestProperties());
    return Promise.all([getContactPropertiesGroups(), getTicketPropertiesGroups()]).then(response => {
      const parsedResponse = parsePropertyResponse(response);
      const properties = flatten(parsedResponse.map(propertyGroup => propertyGroup.properties)).reduce((memo, {
        property
      }) => Object.assign({}, memo, {
        [property.id]: property
      }), {});
      const propertyGroups = parsePropertyGroupsByName(parsedResponse, properties);
      dispatch(succeedFetchingProperties());
      dispatch(receiveProperties(propertyGroups, properties));
    }, error => {
      dispatch(failFetchingProperties(error.xhr));
    });
  };
}